import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import VueLogger from 'vuejs-logger'; 
//import { v4 as uuidv4 } from 'uuid';
import VueGtag from "vue-gtag";
import discovery from "./discovery";
import getBrowserLocale from "@/components/util/get-browser-locale";
import EmptyMain from '@/components/EmptyMain';
import FormularioMain from '@/components/FormularioMain';
//import UpdateSubmission from '@/components/modules/UpdateSubmission';

Vue.config.productionTip = false

// **********************************************************

Vue.use(VueI18n)

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true })
  const supportedLocales = ['es'];
  if (supportedLocales.includes(browserLocale)) {
    return browserLocale
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "es"
  }
}

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
}

export const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'es',
  messages: loadLocaleMessages()
})

// **********************************************************

Vue.use(VueRouter)

const routes = [
  { path: '/', component: EmptyMain },
  { path: '/:token', component: FormularioMain }
]

const router = new VueRouter({
  routes
})

const isProduction = process.env.NODE_ENV === 'production';

// **********************************************************

const options = {
	isEnabled: true,
	logLevel: isProduction ? 'error' : 'debug',
	stringifyArguments: false,
	showLogLevel: true,
	showMethodName: true,
	separator: '|',
	showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(require('vue-moment'));

// **********************************************************

const vue = new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

window.$vue = vue;
window.$store = store;

//FIXME: tiene que ser dinámico
window.$vue.$vuetify.lang.current = 'es'; 

// **********************************************************

Vue.use(VueGtag, {
	config: { id: discovery.wedrive_gtag_id }
}, router);

// **********************************************************

/*if (!window.localStorage.getItem("formio-device-uuid"))
	window.localStorage.setItem("formio-device-uuid", uuidv4().toString().toUpperCase().substring(4, 18));

window.$store.commit('formio/setUuid', window.localStorage.getItem("formio-device-uuid"));*/